export default __webpack_public_path__ + "static/s11-9530e7d3af8a87ac50b9bf76350aec93.jpg";